import { Brand } from "lib/@types/service/product/shared";

const EXCLUDED_BRANDS = ["VA_Brands_Andere"];

// ignore certain brands by code
const brandMapper = (brand: Brand | null): Brand | null => {
    if (brand?.code && !EXCLUDED_BRANDS.includes(brand.code)) {
        return brand;
    }

    return null;
};

export { brandMapper };
